import React, { memo } from 'react';

function NoData({ name, text = 'No Data Available' }) {
  return (
    <div className="no-data-hasname">
      {name && <div className="no-data-name">{name}</div>}
      <div className="no-data">{text}</div>
    </div>
  );
}

export default memo(NoData);
